import { QueryClient } from "@tanstack/react-query"
import { isApiError } from "@/api/client"

/** Statuses that will not get better by retrying. */
const NO_RETRY = new Set([400, 401, 403, 404, 409, 422])

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          if (isApiError(error) && NO_RETRY.has(error.status)) return false
          return failureCount < 2
        },
      },
      mutations: { retry: false },
    },
  })
}

export const queryClient = createQueryClient()
